import { ActionTree } from 'vuex';

import { IKanbanState } from './kanban-states.store';



const actions = <ActionTree<IKanbanState, any>>{    
}
export default actions;